import { render, staticRenderFns } from "./addBnr.vue?vue&type=template&id=88e91a72&scoped=true"
import script from "./addBnr.vue?vue&type=script&lang=js"
export * from "./addBnr.vue?vue&type=script&lang=js"
import style0 from "./addBnr.vue?vue&type=style&index=0&id=88e91a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e91a72",
  null
  
)

export default component.exports